class ReadMore extends HTMLElement {
  connectedCallback() {
    this._target = this.firstElementChild;
    if (!this._target) return;

    // Check if read-more is disabled
    const state = this.getAttribute("state");
    if (state === "off" || state === "false" || state === "no") {
      return; // Do nothing, component is inactive
    }

    this._collapsedClass = this.getAttribute("collapsed-class") || "line-clamp";
    this._expandedText = this.getAttribute("expanded-text") || "Read less";
    this._collapsedText = this.getAttribute("collapsed-text") || "Read more";

    this._target.classList.add(this._collapsedClass);

    // Set line count if specified
    const lines = this.getAttribute("lines");
    if (lines) {
      this._target.style.setProperty("--line-clamp-count", lines);
    }

    // Generate the toggle button
    this._createToggleButton();

    // Delay visibility check until after render
    requestAnimationFrame(() => {
      this._updateVisibility();
    });

    // Add click handler
    this._button.addEventListener("click", this._onToggleClick);

    // Recheck on window resize
    window.addEventListener("resize", () => this._updateVisibility());
  }

  disconnectedCallback() {
    this._button?.removeEventListener("click", this._onToggleClick);
  }

  _createToggleButton() {
    this._wrapper = document.createElement("span");
    this._wrapper.className = "inline-block";

    this._button = document.createElement("a");
    const includeUnderline =
      this.getAttribute("underline") === "yes" ||
      this.getAttribute("underline") === "true";

    this._button.className = `text-with-icon group${includeUnderline ? " underline" : ""}`;
    this._button.href = "#";
    const showChevron = !["hide", "no", "false"].includes(
      this.getAttribute("chevron"),
    );

    this._button.innerHTML = `
      <span class="text" data-read-more-text>${this._collapsedText}</span>
      ${
        showChevron
          ? `<span class="circle-chevron group-hover:colors">
        <svg role="presentation" 
            focusable="false" 
            width="5" 
            height="8" 
            class="icon icon-chevron-right-small reverse-icon" 
            viewBox="0 0 5 8" 
            data-read-more-chevron
            style="transition: transform 0.3s ease; transform: rotate(90deg);">
          <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
        </svg>
      </span>`
          : ""
      }
    `;

    this._wrapper.appendChild(this._button);
    this.appendChild(this._wrapper);

    this._textSpan = this._button.querySelector("[data-read-more-text]");
    this._chevron = this._button.querySelector("[data-read-more-chevron]");
  }

  _onToggleClick = (event) => {
    event.preventDefault();
    this._toggle();
  };

  _toggle() {
    if (this._target.classList.contains(this._collapsedClass)) {
      this._target.classList.remove(this._collapsedClass);
      this._textSpan.textContent = this._expandedText;
      if (this._chevron) this._chevron.style.transform = "rotate(270deg)";
    } else {
      this._target.classList.add(this._collapsedClass);
      this._textSpan.textContent = this._collapsedText;
      if (this._chevron) this._chevron.style.transform = "rotate(90deg)";
    }
  }

  _updateVisibility() {
    if (
      this._target.classList.contains(this._collapsedClass) &&
      this._target.scrollHeight > this._target.clientHeight
    ) {
      this._wrapper.hidden = false;
    } else {
      this._wrapper.hidden = true;
    }
  }
}

if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}
